import { extractVariableLabels, makeVariablePattern, normalizeVariableLabel } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
export const SUBJECT_MAX_LENGTH = 100;
export const MESSAGE_MAX_LENGTH = 400;
export function effectiveContentLength(text) {
    return [
        ...text.replace(makeVariablePattern(), 'x')
    ].length;
}
export function collectUnknownTemplateVariables(subject, message, allowedSystemKeys) {
    const allowedNormalized = new Set();
    allowedSystemKeys.forEach((key)=>allowedNormalized.add(normalizeVariableLabel(key)));
    const seen = new Set();
    const unknown = [];
    for (const name of [
        ...extractVariableLabels(subject),
        ...extractVariableLabels(message)
    ]){
        const normalized = normalizeVariableLabel(name);
        if (allowedNormalized.has(normalized) || seen.has(normalized)) continue;
        seen.add(normalized);
        unknown.push(name);
    }
    return unknown;
}
export function validateDraft(subject, message, allowedSystemKeys) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const errors = {};
    if (!options.skipSubject) {
        const trimmedSubject = subject.trim();
        if (trimmedSubject.length === 0) {
            errors.subject = 'NOTIFICATION_V2_SUBJECT_EMPTY';
        } else if (/[\n\r]/.test(subject)) {
            errors.subject = 'NOTIFICATION_V2_SUBJECT_NEWLINE';
        } else if (effectiveContentLength(trimmedSubject) > SUBJECT_MAX_LENGTH) {
            errors.subject = 'NOTIFICATION_V2_SUBJECT_TOO_LONG';
        }
    }
    const trimmedMessage = message.trim();
    if (trimmedMessage.length === 0) {
        errors.message = 'NOTIFICATION_V2_MESSAGE_EMPTY';
    } else if (effectiveContentLength(trimmedMessage) > MESSAGE_MAX_LENGTH) {
        errors.message = 'NOTIFICATION_V2_MESSAGE_TOO_LONG';
    }
    if (allowedSystemKeys != null) {
        const unknown = collectUnknownTemplateVariables(subject, message, allowedSystemKeys);
        if (unknown.length > 0) errors.unknownTemplateVariables = unknown;
    }
    return errors;
}
export function isDraftValid(errors) {
    return errors.subject == null && errors.message == null && (errors.unknownTemplateVariables == null || errors.unknownTemplateVariables.length === 0);
}
